const REGISTER_FORM_DEFAULT = {
    name: { active: true, type: "string", group: 1 },
    email: { active: true, type: "email", group: 2 },
    country: { active: true, type: "string", group: 3 },
    password: { active: true, type: "password", group: 4 },
    firstName: { active: true, type: "string", group: 1 },
    postalCode: { active: true, type: "number", group: 3 },
    phoneNumber: { active: true, type: "number", group: 0 },
    confirmPassword: { active: true, type: "password", group: 4 },
};

const TOP_BANNER_FILE_ID = "c925473d-03e5-46ad-839a-58489e20e7c4";

const TOP_BANNER_FILE = {
    id: TOP_BANNER_FILE_ID,
    key: "topBannerBackground",
    name: "connextionSubSteps",
    content: "",
    subName: "accountFidelite",
    defaultImage: "",
    defaultContent: "",
};

export function migrateProject(project: ProjectType): any {
    if (!project?.template?.id) return project;

    let next = project;

    const orderTaking = next.template.pages.ways
        ?.orderTaking as OrderTakingPageType;
    if (
        orderTaking?.compositeProduct !== undefined &&
        orderTaking.compositeProduct.isMinMaxShown === undefined
    ) {
        next = {
            ...next,
            template: {
                ...next.template,
                pages: {
                    ...next.template.pages,
                    ways: {
                        ...next.template.pages.ways,
                        orderTaking: {
                            ...orderTaking,
                            compositeProduct: {
                                ...orderTaking.compositeProduct,
                                isMinMaxShown: true,
                            },
                        },
                    },
                },
            },
        };
    }

    const accountFidelite = next.template.pages.subSteps
        ?.accountFidelite as PageType;
    if (accountFidelite && accountFidelite.registerForm === undefined) {
        next = {
            ...next,
            template: {
                ...next.template,
                pages: {
                    ...next.template.pages,
                    subSteps: {
                        ...next.template.pages.subSteps,
                        accountFidelite: {
                            ...accountFidelite,
                            registerForm: REGISTER_FORM_DEFAULT,
                        },
                    },
                },
            },
        };
    }

    if (
        Array.isArray(next.files) &&
        !next.files.find((f: any) => f?.id === TOP_BANNER_FILE_ID)
    ) {
        next = {
            ...next,
            files: [...next.files, TOP_BANNER_FILE],
        };
    }

    const ot = next.template.pages.ways?.orderTaking as OrderTakingPageType;
    if (
        ot?.orderTakingProduct !== undefined &&
        ot.orderTakingProduct.breadcrumbTrail === undefined
    ) {
        next = {
            ...next,
            template: {
                ...next.template,
                pages: {
                    ...next.template.pages,
                    ways: {
                        ...next.template.pages.ways,
                        orderTaking: {
                            ...ot,
                            orderTakingProduct: {
                                ...ot.orderTakingProduct,
                                breadcrumbTrail:
                                    ot.orderTakingProduct.selectedCategoryTitle,
                            },
                        },
                    },
                },
            },
        };
    }

    return next;
}
